import { AssetType, type AssetTypeType } from "@validereinc/domain";

export const getAssetFilters = (
  assetType: AssetTypeType,
  {
    assetId,
    assetName,
  }: {
    assetId: string;
    assetName?: string;
  }
) => {
  const isValidId = (assetIds?: string) => !!assetIds?.length;

  switch (assetType) {
    case AssetType.FACILITY:
      return {
        ...(assetName ? { "facility.name": assetName } : {}),
        ...(isValidId(assetId)
          ? { "facility.id": assetId }
          : { "workflow_template.asset_type": assetType }),
      };
    case AssetType.EQUIPMENT:
      return {
        ...(assetName ? { "equipment.name": assetName } : {}),
        ...(isValidId(assetId)
          ? { "equipment.id": assetId }
          : { "workflow_template.asset_type": assetType }),
      };
    case AssetType.DEVICE:
      return {
        ...(assetName ? { "device.name": assetName } : {}),
        ...(isValidId(assetId)
          ? { "device.id": assetId }
          : { "workflow_template.asset_type": assetType }),
      };
    case AssetType.FLOW:
      return {
        ...(assetName ? { "flow.name": assetName } : {}),
        ...(isValidId(assetId)
          ? { "flow.id": assetId }
          : { "workflow_template.asset_type": assetType }),
      };
    case AssetType.ASSET_GROUP:
      return {
        ...(assetName ? { "asset_group.name": assetName } : {}),
        ...(isValidId(assetId)
          ? { "asset_group.id": assetId }
          : { "workflow_template.asset_type": assetType }),
      };
    default:
      return {};
  }
};
